// extracted by mini-css-extract-plugin
export var chevron = "_l2-4";
export var chevronExpanded = "_l2-5";
export var row = "_l2-0";
export var rowBody = "_l2-6";
export var rowDescription = "_l2-7";
export var rowHeader = "_l2-1";
export var rowTitle = "_l2-2";
export var rowTitleComplete = "_l2-3";